import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../Assets/logo.png';

export default function Login() {
  const [phone, setPhone] = useState('');
  const [isThAvailable, setIsThAvailable] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check th parameter from URL only
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const thFromUrl = params.get('th');
    
    if (thFromUrl && thFromUrl.trim() !== '') {
      // Valid th parameter found in URL
      localStorage.setItem('th', thFromUrl);
      setIsThAvailable(true);
    } else {
      // No th parameter in URL - disable login
      setIsThAvailable(false);
    }
  }, [location.search]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isThAvailable) {
      return;
    }
    const fullNumber = '55' + phone.replace(/\D/g, '');
    localStorage.setItem("cellphone", fullNumber);
    navigate('/verify');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-purple via-brand-purple-light to-brand-teal flex flex-col items-center justify-center px-6 py-8">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20" style={{backgroundImage: "url('data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.05%27%3E%3Ccircle cx=%2730%27 cy=%2730%27 r=%272%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"}}></div>
      
      {/* Main Content */}
      <div className="relative z-10 w-full max-w-sm">
        {/* Logo Container */}
        <div className="text-center mb-8 animate-fade-in">
          <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-6 shadow-2xl mb-6">
            <img src={logo} alt="VisageAI logo" className="block max-w-[160px] w-full h-auto mx-auto" />
          </div>
          <div className="space-y-2">
            <h1 className="text-white text-2xl font-bold tracking-tight">Bem-vindo ao VisageAI</h1>
            <p className="text-white/90 text-sm">Sua jornada de beleza começa aqui</p>
          </div>
        </div>

        {/* Form Container */}
        <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-6 shadow-2xl">
          <div className="text-center mb-6">
            <h2 className="text-brand-purple text-xl font-semibold mb-2">Digite seu WhatsApp</h2>
            <p className="text-gray-600 text-sm">Enviaremos um código de verificação</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-2">Número de telefone</label>
              <div className="flex items-stretch border-2 border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm focus-within:border-brand-teal focus-within:ring-2 focus-within:ring-brand-teal/20 transition-all duration-300">
                <span className="bg-gradient-to-r from-brand-teal to-brand-teal-dark text-white px-4 py-4 font-semibold flex items-center justify-center text-sm">
                  🇧🇷 +55
                </span>
                <input
                  type="tel"
                  placeholder="(11) 99999-9999"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                  className="border-none outline-none px-4 py-4 text-base w-full box-border placeholder-gray-400 focus:placeholder-gray-300 transition-colors"
                />
              </div>
            </div>
            
            <button 
              type="submit" 
              disabled={!isThAvailable}
              className={`w-full border-none rounded-2xl py-4 px-6 font-semibold text-base transition-all duration-300 transform shadow-lg ${
                isThAvailable
                  ? 'bg-gradient-to-r from-brand-teal to-brand-teal-dark hover:from-brand-teal-dark hover:to-brand-teal text-white hover:scale-[1.02] active:scale-[0.98] hover:shadow-xl'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              <span className="flex items-center justify-center gap-2">
                Continuar
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
            </button>
          </form>
          
          {/* Company Status */}
          {!isThAvailable && (
            <div className="mt-6 p-4 bg-red-50 rounded-xl border border-red-200">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <div>
                  <p className="text-red-800 font-medium text-sm">Empresa não identificada</p>
                  <p className="text-red-600 text-xs mt-1">
                    Acesse através do link fornecido pela Clínica
                  </p>
                </div>
              </div>
            </div>
          )}
          

          {/* Security Badge */}
          <div className="flex items-center justify-center gap-2 mt-6 pt-4 border-t border-gray-100">
            <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
            </svg>
            <span className="text-xs text-gray-500">Seus dados estão seguros conosco</span>
          </div>
        </div>
      </div>
    </div>
  );
}
